import React, { useEffect, useState, useCallback } from "react";
import { Button, Descriptions, Space, PageHeader } from "antd";

import { useParams, useHistory } from "react-router-dom";
import { helpers, dateUtil } from "../../utils";
import { requests, getUrl } from "../../globals/requests";

function Transaction(props) {
  const [transaction, setTransaction] = useState({});
  const [loadingMarkFailed, setLoadingMarkFailed] = useState(false);
  const [loadingMarkSuccess, setLoadingMarkSuccess] = useState(false);

  const { transactionId } = useParams();
  const history = useHistory();

  async function setTransactionAsFailed() {
    try {
      const ans = window.confirm("Are you sure you want to mark as `failed` ?");
      if (!ans) return;
      setLoadingMarkFailed(true);
      const url = `${getUrl("transactions")}/${transactionId}/failed`;
      const response = await requests.getWithAuth(url);
      setLoadingMarkFailed(false);
      setTransaction(response.data);
      helpers.successModal({
        title: "Transaction marked as failed",
        content:
          "This transaction status has been set as failed and the plan has been refunded",
      });
    } catch (e) {
      helpers.displayMessage(e);
      setLoadingMarkFailed(false);
    }
  }

  async function setTransactionAsSuccess() {
    try {
      const ans = window.confirm(
        "Are you sure you want to mark as `success` ?"
      );
      if (!ans) return;
      setLoadingMarkSuccess(true);
      const url = `${getUrl("transactions")}/${transactionId}/success`;
      const response = await requests.getWithAuth(url);
      setLoadingMarkSuccess(false);
      setTransaction(response.data);
      helpers.successModal({
        title: "Status set to success",
        content: "This transaction status has been set as success",
      });
    } catch (e) {
      helpers.displayMessage(e);
      setLoadingMarkSuccess(false);
    }
  }
  useEffect(() => {
    async function getTransaction() {
      try {
        const url = `${getUrl("transactions")}/${transactionId}`;
        const response = await requests.getWithAuth(url);
        setTransaction(response.data);
      } catch (e) {
        helpers.displayMessage(e);
      }
    }

    getTransaction();
  }, [transactionId]);

  const getTtitle = useCallback(() => {
    if (transaction?.reference) return `Reference: ${transaction?.reference}`;

    return "";
  }, [transaction?.reference]);
  return (
    <Space direction="vertical" size="large" style={{ display: "flex" }}>
      <PageHeader
        className="site-page-header"
        onBack={() => history.goBack()}
        title="Transaction"
      />
      <p>{transaction?.description}</p>
      <Descriptions bordered title={getTtitle()} size="default">
        <Descriptions.Item label="Action">
          {transaction?.action}
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          {transaction?.status}
        </Descriptions.Item>
        <Descriptions.Item label="Amount">
          {helpers.toCurrency(transaction?.amount)}
        </Descriptions.Item>
        <Descriptions.Item label="Source">
          {transaction?.source}
        </Descriptions.Item>
        <Descriptions.Item label="Destination">
          {transaction?.destination}
        </Descriptions.Item>
        <Descriptions.Item label="Reference">
          {transaction?.reference}
        </Descriptions.Item>
        <Descriptions.Item label="Payment Attempted On">
          {dateUtil.formatDate(transaction?.paidAt)}
        </Descriptions.Item>
        <Descriptions.Item label="Processed By">
          {transaction?.processedBy}
        </Descriptions.Item>
        {!!transaction?.statusUpdatedAt && (
          <Descriptions.Item label="Resolved by admin on">
            {dateUtil.formatDate(transaction?.statusUpdatedAt)}
          </Descriptions.Item>
        )}
      </Descriptions>
      <Descriptions
        bordered
        title=""
        size="default"
        extra={
          transaction?.status === "pending" ? (
            <Space size="small">
              <Button
                loading={loadingMarkFailed}
                onClick={setTransactionAsFailed}
              >
                Mark as fail
              </Button>
              <Button
                loading={loadingMarkSuccess}
                type="primary"
                onClick={setTransactionAsSuccess}
              >
                Mark as success
              </Button>
            </Space>
          ) : null
        }
      />
    </Space>
  );
}

export default Transaction;
